import PropTypes from 'prop-types'
import { capitalize } from 'lodash'
import { useTranslation } from 'react-i18next'

import DropdownDots from '../../../../../components/DropdownDots/DropdownDots'
import ToggleWithText from '../../../../../components/ToggleWithText/ToggleWithText'
import EditableDaysCell from '../EditableDaysCell/EditableDaysCell'
import Badge from '../../../../../components/Badge/Badge'
import { checkListOptions } from '../../Tabs/Settings/helpers'

const TaskItem = ({
  dragHandleProps = {},
  updateTaskActivity = () => {},
  onEdit = () => {},
  task,
}) => {
  const { t } = useTranslation(['checklists-settings'])
  const onSwitch = () => updateTaskActivity(task)

  return (
    <div onClick={() => onEdit(task)} className="task-item">
      <div className="task-item__header" {...dragHandleProps}>
        <div className="task-item__header__dots">
          <div className="task-item__header__dot" />
          <div className="task-item__header__dot" />
          <div className="task-item__header__dot" />
          <div className="task-item__header__dot" />
          <div className="task-item__header__dot" />
          <div className="task-item__header__dot" />
        </div>
      </div>
      <div className="task-item__body">
        <div className="task-item__body__head">
          <div className="task-item__body__head__title">
            <span>{task.name}</span>
            {!!task.inspectionsCount && (
              <Badge color="purple">
                {t('checklists-settings:taskItem.inspectionsActive', {
                  count: task.inspectionsCount,
                })}
              </Badge>
            )}
          </div>
          <div className="task-item__body__head__controls">
            <ToggleWithText
              text={
                task.isActive
                  ? t('checklists-settings:taskItem.activeLabel')
                  : t('checklists-settings:taskItem.inactiveLabel')
              }
              onChange={() => onSwitch()}
              isChecked={task.isActive}
              color={'#548671'}
            />
            {task.type === 'task' && (
              <DropdownDots options={checkListOptions({ task, onEdit, t })} />
            )}
          </div>
        </div>
        <div className="task-item__body__content">
          <table>
            <thead>
              <tr>
                <th>{t('checklists-settings:shared.typeHeader')}</th>
                {task.type !== 'task' && (
                  <th>{t('checklists-settings:taskItem.inspectionsIncludedHeader')}</th>
                )}
                {task.type === 'task' && (
                  <th>{t('checklists-settings:customTasks.assignTriggerHeader')}</th>
                )}
                {task.type === 'task' && (
                  <th>{t('checklists-settings:customTasks.dueDateHeader')}</th>
                )}
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{capitalize(task.type)}</td>
                {task.type !== 'task' && <td>{task.inspectionsCount}</td>}
                <td>
                  <EditableDaysCell
                    data={{
                      id: task.id,
                      condition: task.assignTaskRelative,
                      trigger: task.assignTaskTrigger,
                      days: task.assignTaskDays,
                      name: 'assignTask',
                    }}
                  />
                </td>
                <td>
                  <EditableDaysCell
                    data={{
                      id: task.id,
                      condition: task.dueDateCondition,
                      trigger: task.dueDateTrigger,
                      days: task.dueDateDays,
                      name: 'dueDate',
                    }}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

TaskItem.propTypes = {
  dragHandleProps: PropTypes.object,
  task: PropTypes.object,
  updateTaskActivity: PropTypes.func,
  onEdit: PropTypes.func,
}

export default TaskItem
